export { default } from './OrderInformation';



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/OrderInformation/index.js